// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__19Q3b","tip-title":"Tip_tip-title__3b35w","tip-text":"Tip_tip-text__GIgl3"};